import { NudosGenericModal, NudosModalContent } from '../../../../../../../../components/NudosComponents';
import {
  TEMPORARY_STORAGE_REASON_TYPE_ID,
  IShipmentData,
  IproductReferenceDataInCountry
} from '../../../../../../../../types/orders';
import {
  IWarehouseTemporaryStorageModalCustomSectionInitialValues,
  WarehouseTemporaryStorageModalCustomSection
} from './WarehouseTemporaryStorageModalCustomSection';
import { IconReserveBox } from 'assets/DesignSystem/SVGComponents';
import BordBadge from 'components/NudosComponents/BordBadge/BordBadge';
import { getReasonForStopWarehouse } from 'utils/getReasonForStopWarehouse';
import './WarehouseTemporaryStorageModal.scss';

export const WarehouseTemporaryStorageModal = ({
  shipmentId,
  initialValues,
  reasonsForTemporaryStorage,
  closeModalCallback,
  reloadDataCallback,
  organizationName,
  orderId,
  flag,
  shipmentData,
  receiverName,
  references,
  listOfShipmentsAvailableToAdd,
  listOfSelectedShipments
}: IWarehouseTemporaryStorageModalProps) => {
  return (
    <div className="warehouseTemporaryStorageModal">
      <NudosGenericModal
        modalContent={
          <NudosModalContent
            customWidth="1048px"
            customHeight="744px"
            modalContentTitle={
              <div className="modalContentTitleContainer">
                <span>Parada en bodega por: </span>
                {reasonsForTemporaryStorage.length > 0 && (
                  <div className="selectedReasonsContainer">
                    <div className="badgesContainer">
                      {reasonsForTemporaryStorage?.map(reasonId => (
                        <BordBadge
                          key={reasonId}
                          variant="secondary"
                          size="sm"
                          label={getReasonForStopWarehouse(reasonId)}
                        />
                      ))}
                    </div>
                  </div>
                )}
              </div>
            }
            customHeaderClass="warehouseTemporaryStorageModalHeader"
            toCloseModal={closeModalCallback}
            customIcon={
              <div className="iconContainer">
                <IconReserveBox />
              </div>
            }
            CustomModalComponent={
              <WarehouseTemporaryStorageModalCustomSection
                shipmentId={shipmentId}
                initialValues={initialValues}
                reasonsForTemporaryStorage={reasonsForTemporaryStorage}
                closeModalCallback={closeModalCallback}
                reloadDataCallback={reloadDataCallback}
                organizationName={organizationName}
                orderId={orderId}
                flag={flag}
                shipmentData={shipmentData}
                receiverName={receiverName}
                references={references}
                listOfShipmentsAvailableToAdd={listOfShipmentsAvailableToAdd}
                listOfSelectedShipments={listOfSelectedShipments}
              />
            }
          />
        }
      />
    </div>
  );
};

interface IWarehouseTemporaryStorageModalProps {
  references?: IproductReferenceDataInCountry[];
  shipmentId: number;
  initialValues: IWarehouseTemporaryStorageModalCustomSectionInitialValues;
  reasonsForTemporaryStorage: TEMPORARY_STORAGE_REASON_TYPE_ID[];
  closeModalCallback: () => void;
  reloadDataCallback?: () => Promise<void>;
  organizationName?: string;
  orderId?: string;
  receiverName?: string;
  flag?: string | null;
  shipmentData?: IShipmentData;
  listOfShipmentsAvailableToAdd?: IShipmentData[];
  listOfSelectedShipments?: IShipmentData[];
}
